import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FocusWithin from 'react-focus-within';
import styles from './TextArea.module.scss.js';
import FormField, { FormFieldPropTypes, FormFieldInputPropTypes } from '../FormField/index.js';

var _excluded = ["className", "disabled", "placeholder", "type", "input", "meta", "label", "required", "autoFocus", "themeColor", "fieldProps", "maxLength"];
var FormTextArea = function FormTextArea(_ref) {
  var className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    placeholder = _ref.placeholder,
    type = _ref.type,
    input = _ref.input,
    meta = _ref.meta,
    label = _ref.label,
    required = _ref.required,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? '#7A34FF' : _ref$themeColor,
    fieldProps = _ref.fieldProps,
    maxLength = _ref.maxLength,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(0),
    count = _useState[0],
    setCount = _useState[1];
  useEffect(function () {
    if (maxLength) {
      setCount(input.value.length);
    }
  }, [input.value]);
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: label,
    input: input,
    required: required,
    meta: meta
  }, fieldProps), /*#__PURE__*/React.createElement(FocusWithin, props, function (_ref2) {
    var _cx;
    var isFocused = _ref2.isFocused,
      focusProps = _ref2.focusProps;
    return /*#__PURE__*/React.createElement("div", _extends({}, focusProps, {
      className: cx(styles.container, (_cx = {}, _cx[styles.error] = meta.touched && meta.error, _cx[styles.disabled] = disabled, _cx))
    }), /*#__PURE__*/React.createElement("textarea", _extends({
      className: cx(styles.input, className),
      disabled: disabled,
      type: type,
      id: input.name,
      placeholder: placeholder,
      autoFocus: autoFocus
    }, input, {
      style: isFocused ? {
        borderColor: themeColor
      } : {},
      maxLength: maxLength
    })), maxLength && /*#__PURE__*/React.createElement("p", {
      className: styles.count
    }, count, "/", maxLength));
  }));
};
FormTextArea.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  fieldProps: PropTypes.shape(FormFieldPropTypes),
  input: PropTypes.shape(FormFieldInputPropTypes),
  label: PropTypes.node,
  meta: PropTypes.object.isRequired,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['password', 'email', 'text']),
  themeColor: PropTypes.string
};

export { FormTextArea as default };
//# sourceMappingURL=index.js.map
